(function () {
    'use strict';

    var module = angular.module('uwAgenda.global');
    module.directive('currentOwnerTitle', [                
        'SharedAgendaService', 
        'SharedAgendaBroadcast',
        CurrentOwnerTitle
    ]);
    
    function CurrentOwnerTitle(SharedAgendaService, SharedAgendaBroadcast) {
        var directive = {
            link: link,
            restrict: 'E',
            templateUrl: '/app/global/components/current-owner-title/current-owner-title.html'
        };
        return directive;

        function link(scope, element) {

            scope.currentOwner = SharedAgendaService.currentUser();

            listen();

            function listen() {
                var agendaChangedListener = scope.$on(SharedAgendaBroadcast.AgendaOwnerChanged, function () {
                    scope.currentOwner = SharedAgendaService.currentUser();
                }); 
                
                scope.$on('$destroy', function () {
                    if (agendaChangedListener) {
                        agendaChangedListener();
                        agendaChangedListener = null;
                    }
                });
            }
        }
    }
})();